/* eslint-disable import/first */

//region 1. Platform Libraries
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../event-status', () => {
    const dataAPI = new DataAPI();

    before(function before(done) {
        this.timeout(3000);
        dataAPI.initialize({
            environment: 'unit-test',
            heartbeatInterval: 10,
            logLevel: 'ERROR',
            mongoUrl: process.env.CLIO_MONGO_URL,
            port: 15925,
        });
        dataAPI.start(done);
    });

    describe('PUT', () => {
        it('should create new event status', (done) => {
            request(dataAPI.expressApp)
                .put('/cameras/123456789a123456789b1234/streams/0/event-status')
                .send({ status: 'activated' })
                .expect(200)
                .end(/** @type function */done);
        });

        it('should fail if no body', (done) => {
            request(dataAPI.expressApp)
                .put('/cameras/123456789a123456789b1234/streams/0/event-status')
                .expect(400)
                .end(/** @type function */done);
        });

        it('should fail if no status', (done) => {
            request(dataAPI.expressApp)
                .put('/cameras/123456789a123456789b1234/streams/0/event-status')
                .send({ message: 'activated' })
                .expect(400)
                .end(/** @type function */done);
        });
    });

    after(done => dataAPI.stop(done));
});
